// TODO: Need to determine the correct versions
import { INTERFACE_IDS as INTERFACE_IDS_VX } from '@lukso/lsp-smart-contracts'
import { ResultOrError } from '@lukso/controllerapps-sharedlogic-ddd-core'
import {
  HexNumber,
  Address,
  ChainID,
} from '@lukso/controllerapps-sharedlogic-primitives'

import { ProfileContractCallError } from '@/business-logic/profile/domain/errors'
import { ViemEIP165Contract } from './ViemEIP165Contract/ViemEIP165Contract'
import { InterfaceID } from '@/business-logic/profile/domain/InterfaceID'
import { UniversalReceiverContract } from '@/business-logic/profile/domain/contracts/UniversalReceiverContract'

// TODO: Need to determine the correct versions of all below for all UP versions that we support. We should also
// document these versions in the README, not just for profiles, but for all the LSPs we support.
const interfaceID_VX = InterfaceID.create({
  interfaceIDValue: HexNumber.create({
    hexNumberValue: INTERFACE_IDS_VX.LSP1UniversalReceiverDelegate,
  }),
})

export class ViemUniversalReceiverContract
  implements UniversalReceiverContract
{
  constructor(private readonly eip165Contract: ViemEIP165Contract) {}

  public async isUniversalReceiver(
    address: Address,
    chainID: ChainID
  ): Promise<ResultOrError<boolean, ProfileContractCallError>> {
    return this.eip165Contract.supportsInterface(
      address,
      interfaceID_VX,
      chainID
    )
  }
}
